<template>
  <div class="mb-4">
    <button class="btn btn-info btn-icon mw mt-4" @click="sendRequest">
      {{ "create_query" | setText("Сформировать заявку") }}
    </button>
  </div>
</template>
<script>
import {
  logger,
  errorNotify,
  toFormData,
  dateConvert,
  addMonth,
} from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);
      const url = `${this.currentRequest.service.api_endpoint_url}contract`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };
      //DATA

      let data = {
        transaction_info: {
          tr_id: this.data.id,
          user_id: this.user_id,
        },
        tex_info: {
          tex_id: 1,
          marka: this.data.type_object.vendor,
          model: this.data.type_object.model,
          tex_name: "Smartphone",
          sery_num: this.data.type_object.serial,
          buy_date: dateConvert(this.data.date_paid),
          buy_place: this.data.shop.name,
        },
        insurance_info: {
          insurance_sum: this.data.price,
        },
        person_info: {
          surname: this.data.client_last_name,
          name: this.data.client_first_name,
          patronymic: this.data.client_family_name,
          birthday: dateConvert(this.data.client_birthday),
          pinfl: this.data.client_pinfl,
          passport: {
            series: this.data.client_passport.substring(0, 2),
            number: this.data.client_passport.substring(2),
          },
          address: this.data.client_address,
          phone: this.data.client_phone.replace("+", ""),
        },
      };

      //REQUEST
      return this.$http({
        method: method,
        data: data,
        url: url,
        headers: headers,
      })
        .then((response) => {
          const responseData = response.data;

          if (responseData) {
            switch (responseData.result) {
              case 0:
                this.$emit("input", {
                  exchange_id: responseData.contract_id,
                  service_request: {
                    state: "sent",
                    service: "apex",
                    exchange_id: responseData.contract_id,
                    response: JSON.stringify(responseData),
                    body: JSON.stringify(data),
                  },
                });
                break;

              default:
                break;
            }

            if (responseData.result_message) {
              this.$notify({
                title: "APEX",
                message: responseData.result_message,
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }

          return responseData;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  props: ["value", "data", "currentRequest", "user_id"],
};
</script>
<style>
</style>
 